import { css } from "@emotion/react";

import { white, red, redDark, blue, blueDark, black, greyLight } from "../../styles/variables";

export const whiteColor = css`
  &.MuiButton-contained {
    color: ${black};
    background-color: ${white};
  }
  &.MuiButton-contained:hover {
    background: ${greyLight};
  }

  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1);
`;

export const errorColor = css`
  &.MuiButton-contained {
    color: ${white};
    background-color: ${red};
  }
  &.MuiButton-contained:hover {
    background-color: ${redDark};
  }
  &.MuiButton-outlined {
    color: ${red};
    border: 1px solid ${red};
  }
  &.MuiButton-outlined:hover {
    color: ${white};
    background-color: ${red};
  }

  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1);
`;

export const btn = css`
  &.Mui-disabled {
    opacity: 0.3;
  }
  &.MuiButton-containedPrimary {
    color: ${white};
    background-color: ${blue};
  }
  &.MuiButton-containedPrimary:hover {
    background-color: ${blueDark};
  }

  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1);
`;
